import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { VortexUICurrentAttempt } from "../../../../components/ui/hud/VortexUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";

export default class GeneralProceduresNeutralStateMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresNeutralStateMainConfig) {
		super();
	}

	public start() {
		const context = this;
		var isDebug = false;
		if(isDebug) {
			context.config.scenario.showDefaultSideMenu();

			setTimeout(() => {
				context.config.scenario.sideMenuId = context.config.scenario.uiWrapper.displaySideMenu({
					updatedStuff: {

					}
				}, context.config.scenario.sideMenuId);
			}, 0);
		}
		context.config.scenario.toolbagId = context.config.scenario.uiWrapper.displayToolbag({
			isTestScenario: context.config.isTestScenario,
			toolsToChooseFrom: isDebug ? [
				//Tool Bag
				constants.toolbagTools.bvm,
				constants.toolbagTools.ett,
				constants.toolbagTools.sga,
				constants.toolbagTools.cric

				//Cric Tools
				// constants.cricTools.bougie,
				// constants.cricTools.ett,
				// constants.cricTools.scalpel,
				// constants.cricTools.spreader,
				// constants.cricTools.syringe
			] : null,
			onShouldShowOverlay: () => {
				return isDebug;
			},
			onToolClicked: (data: DraggedSingleData) => {
				if(!isDebug && !context.config.areToolsAvailable()) {
					context.config.scenario.uiWrapper.displayGeneralAlertUI({
						title: 'Please Wait',
						text: 'Please wait until after induction before starting any procedures',
						okButton: {
							title: 'ok',
							onClicked: () => {

							}
						}
					})
					return;
				}
				context.config.scenario.toolbagId = context.config.scenario.uiWrapper.displayToolbag({
					isDisabled: true,
					isTestScenario: context.config.isTestScenario
				}, context.config.scenario.toolbagId);

				context.config.scenario.sideMenuId = context.config.scenario.uiWrapper.displaySideMenu({
					updatedStuff: {
						notBreathing: true
					}
				}, context.config.scenario.sideMenuId);


				switch(data.text.toLowerCase()) {
					case 'bvm':
						if(context.config.goToBvm) {
							context.config.goToBvm();
						}
						break;
					case 'ett':
						if(context.config.goToEtt) {
							context.config.goToEtt();
						}
						break;
					case 'sga':
						if(context.config.goToSga) {
							context.config.goToSga();
						}
						break;
					case 'cric':
						if(context.config.goToCric) {
							context.config.goToCric();
						}
						break;
				}
			},
			onToolsArranged: (text: string[]) => {}
		}, context.config.scenario.toolbagId);
	}
}

export interface GeneralProceduresNeutralStateMainConfig extends BaseGeneralConfig { 
	scenario: DaarcBaseScenario;
	goToBvm: () => void;
	goToEtt: () => void;
	goToSga: () => void;
	goToCric: () => void;
	areToolsAvailable: () => boolean;
}